var relatedproducts = [];
var done = false;
var iterations = 0;
var sleeptime = 2000;
var dialog;
var autogeocoderoswell = true;

function related(color)
{
 	var colors =  getRelatedColors(color);
  d = new Date();
  console.log(d.getTime().toString() + ' in related');
  	if (colors == '')
      return;
  	colors.splice(0, 1);
    for(var i = colors.length - 1; i >= 0; i--) {
      if(colors[i] == '' || colors[i] == 'MASTER') {
         colors.splice(i, 1);
      }
	}

  	data = JSON.parse(localStorage.getItem('_products'));
    relatedproducts = [];
    var last = '';
    for (var i in data.products)
    {
      for (var j in colors)
      {
     	 if (data.products[i].title.indexOf(colors[j]) > -1)
         {
           if (data.products[i].title != last)
           relatedproducts.push(data.products[i]);
           last = data.products[i].title;
         }
      }
    }
  loadRelated();
  d = new Date();
  console.log(d.getTime().toString() + ' out related');
}

function loadRelated() 
{
  if (done == true)
  {
   	$("#m-related").data('owlCarousel').destroy();
  }
  $('ul#m-related li:gt(0)').remove();
  
  var cnt = 10;
  
  for (var x in relatedproducts)
  {
    if (cnt-- <= 0) {
      $('ul#m-related li:eq(0)').remove();
        goCarousel();
        return;
    }    
  $('ul#m-related li').last().after($('ul#m-related li').last().clone().css('display','block'));
    if (relatedproducts[x].image)
    	$('ul#m-related li').last().find('img').attr('src',relatedproducts[x].image.replace('.jpg','_large.jpg'));
    $('ul#m-related li').last().find('a').attr('href',relatedproducts[x].url);
    $('ul#m-related li').last().find('a').attr('title',relatedproducts[x].title);
    $('ul#m-related li').last().find('h3').html(relatedproducts[x].title);
    $('ul#m-related li').last().find('.price').html(relatedproducts[x].price);
  }

  $('ul#m-related li:eq(0)').remove();
  	goCarousel();
}

function chooseStore(me)
{
  console.log(me);
  console.log('!!!');
    var store = $(me).parent().find('span.scasl-tags').html() + ' ' + $(me).parent().find('#scasl-title').html();
    var address = $(me).parent().find('#scasl-address').html();
    var phone = $(me).parent().find('#scasl-phone').html().replace('<span id="scasl-phone-label"></span> ','');
    var name = $(me).parent().find('#scasl-title').html();
    var code = $(me).parent().find('span.scasl-tags').html();
  	if (window.parent.location.href.indexOf("pages/dr") == -1 && window.parent.location.href.indexOf("dressing-room-create") == -1)
    {
      localStorage.setItem('_store', store);
      localStorage.setItem('_store_address', address);
      localStorage.setItem('_store_phone', phone);
      localStorage.setItem('_store_name', name);
      localStorage.setItem('_store_code', code);
      if ($('#weardate').length > 0)
        setNote();
    }
    else
    {
      localStorage.setItem('_store_dr', store);
      localStorage.setItem('_store_dr_address', address);
      localStorage.setItem('_store_dr_phone', phone);
      localStorage.setItem('_store_dr_name', name);
      localStorage.setItem('_store_dr_code', code);
      $(window.parent.document).find('.party-container').find('h2').find('span:eq(0)').html(name);
      updateDressingRoomStore();
    }
    $(window.parent.document).find("#myiFrame").removeClass('show');
    $(window.parent.document).find('#storeFrame').hide();
  	if ($(window.parent.document).find('.storedetails').length > 0)
  		$(window.parent.document).find('.storedetails').find('p').first().html(name + ', ' + address + ', ' + phone);
}

function goCarousel()
{
  done = true;
  $("#m-related").owlCarousel({
    navigation : true,
    nav: true,
    navigationText: ["",""],
    slideSpeed : 300,
    paginationSpeed : 400,
    singleItem: false,
    pagination: true,
    addClassActive: true,
    loop: true,
    slideBy: 2,
    items: 4,
    responsive: {
      0 : {
          loop : true,
          items: 2,
      },
      480 : {
          loop : true,
          items: 2,
      },
      768 : {
          loop : true,
          items: 4,
      }
    }
  });
}

function getRelatedColors(chilcol)
  {
    if (!$('#colors').val())
      return '';
  	var groups = $('#colors').val().split("*");
//    console.log(groups);
//    console.log($('#colors').val());
    for (var i in groups)//look for exact match first
    {
      var sings = groups[i].split(',');
      for (var j in sings)
      {
      	if (sings[j] == chilcol)
          return sings;
      }
    }
    for (var i in groups)//look for like match second
    {
      var sings = groups[i].split(',');
      for (var j in sings)
      {
      	if (sings[j].indexOf(chilcol) > -1)
          return sings;
      }
    }
    return '';
  }

function getClosestStore(zipcode)
{
  if (zipcode.length < 5)
    return;
 	//$('#storeFrame').show();
    //$("#myiFrame").addClass('show');
    autogeocoderoswell = false;
    var iframe = $("#myiFrame");
    //$('#bh-sl-map-container').storeLocator.autoGeocode = false;

    iframe.attr("src", iframe.data("src"));


    iterations = 0;
                              dialog = $("<div id='dialog-message'>Retrieving closest store!  Please wait...</div>").dialog({
                                dialogClass:"notification",
                                width: 600,
                                maxWidth: 600,
                                height: 'auto',
                                modal: true,
                                fluid: true, //new option
                                resizable: false
                              });
    goHijackMap(zipcode);
    //$('#bh-sl-map-container').storeLocator.autoGeocode = true;
  	autogeocoderoswell = true;
}

function goHijackMap(zipcode)
{
  var sleep = false;
  if (iterations++ > 15)
  {
    $(dialog).dialog('close');
    createDressingRoom($('#create').serialize());
    return;
  }

  if ($('#myiFrame').length == 0)
    sleep = true;
  else if ($('#myiFrame').contents().find('#bh-sl-address').length == 0)
    sleep = true;

  if (sleep == true)
  {
	setTimeout(function(){
		goHijackMap(zipcode);
	}, 1000);
  }
  else
  {
     $('#myiFrame').contents().find('#bh-sl-address').val(zipcode);
     iterations = 0;
     goHijackGetData();
  }
}

function goHijackGetData()
{
  var sleep = false;
  if (iterations++ > 5)
  {
    $(dialog).dialog('close');
    createDressingRoom($('#create').serialize());
    return;
  }

  if ($('#myiFrame').contents().find('#scasl-title').length == 0)
    sleep = true;


  if (sleep == true)
  {
	setTimeout(function(){
		goHijackGetData();
	}, 1000);
  }
  else
  {
    $(dialog).dialog('close');
    var store = $('#myiFrame:first').contents().find('span.scasl-tags').html() + ' ' + $('#myiFrame:first').contents().find('#scasl-title').html();
    var address = $('#myiFrame:first').contents().find('#scasl-address').html();
    var phone = $('#myiFrame:first').contents().find('#scasl-phone').html().replace('<span id="scasl-phone-label"></span> ','');
    var name = $('#myiFrame:first').contents().find('#scasl-title').html();
    var code = $('#myiFrame:first').contents().find('span.scasl-tags').html()

    localStorage.setItem('_store_dr', store);
    localStorage.setItem('_store_dr_address', address);
    localStorage.setItem('_store_dr_phone', phone);
    localStorage.setItem('_store_dr_name', name);
    localStorage.setItem('_store_dr_code', code);

    $('#store').val(store);
    $('#store_address').val(address);
    $('#store_phone').val(phone);
    $('#store_name').val(name);
    $('#store_code').val(code);
    $('#create').serialize();
    createDressingRoom($('#create').serialize());
    //alert($('#myiFrame:first').contents().find('#scasl-title').html());
    //alert($('#myiFrame:first').contents().find('span.scasl-tags').html());
  }
}

function goHijackMapAutolocate()
{
  var sleep = false;
  if (iterations++ > 15)
  {
    return;
  }

  console.log($('#myiFrame').contents().find('#bh-sl-address').val());

  if ($('#myiFrame').contents().find('#bh-sl-address').length == 0)
    sleep = true;
  else if ($('#myiFrame').contents().find('#bh-sl-address').val() == 0)
    sleep = true;

  if (sleep == true)
  {
    if ($('#myiFrame').contents().find('#scapl-geocode-btn').length != 0)
    {
      	sleeptime = 6000;
    	$('#myiFrame').contents().find('#scapl-geocode-btn').click();
    }
	setTimeout(function(){
		goHijackMapAutolocate();
	}, sleeptime);
  }

}
